import NoticeList from '@/views/primary/notice/NoticeList';
import NoticeAdd from '@/views/primary/notice/NoticeAdd';
import NoticeEdit from '@/views/primary/notice/NoticeEdit';
import NoticeDetail from '@/views/primary/notice/NoticeDetail';

import SettingLayout from '@/views/primary/setting/SettingLayout';

import SignupSetting from '@/views/primary/setting/SignupSetting';
import NotifySetting from '@/views/primary/setting/NotifySetting';
import GroupingSetting from '@/views/primary/setting/GroupingSetting';
import ReviewSetting from '@/views/primary/setting/ReviewSetting';
import TicketWindowSetting from '@/views/primary/setting/TicketWindowSetting';
import SendMessage from '@/views/primary/setting/SendMessage';

import SignupLayout from '@/views/primary/signup/SignupLayout';
import SignupList from '@/views/primary/signup/SignupList';
import SignupDetail from '@/views/primary/signup/SignupDetail';
import SignupAdd from '@/views/primary/signup/SignupAdd';
import OccupiedStudentList from '@/views/primary/signup/OccupiedStudentList';

import OuterNotice from '@/views/primary/outer/OuterNotice';
import OuterLogin from '@/views/primary/outer/OuterLogin';
import OuterQuestionnaire from '@/views/primary/outer/OuterQuestionnaire';
import OuterQuestionnaireDetail from '@/views/primary/outer/OuterQuestionnaireDetail';

import ReviewLayout from '@/views/primary/review/ReviewLayout';
import ReviewOnline from '@/views/primary/review/ReviewOnline';
import ReviewOffline from '@/views/primary/review/ReviewOffline';
import ReviewReserve from '@/views/primary/review/ReviewReserve';
import ReviewQuestionnaireDetail from '@/views/primary/review/ReviewQuestionnaireDetail';

import AccountingLayout from '@/views/primary/accounting/AccountingLayout';
import DataAccounting from '@/views/primary/accounting/DataAccounting';
import SignupAccounting from '@/views/primary/accounting/SignupAccounting';
import ReviewAccounting from '@/views/primary/accounting/ReviewAccounting';

import MessageTemplateList from '@/views/messageTemplate/MessageTemplateList';

import infoSearchList from '@/views/primary/setting/infoSearch/infoSearchList';
import infoSearchAdd from '@/views/primary/setting/infoSearch/infoSearchAdd';
import infoSearchResultList from '@/views/primary/setting/infoSearch/infoSearchResultList';


export const primaryMainRouterList = [{
    path: 'primary/notice/noticeList',
    name: 'primaryNoticeList',
    component: NoticeList
}, {
    path: 'primary/notice/noticeAdd',
    name: 'primaryNoticeAdd',
    component: NoticeAdd
}, {
    path: 'primary/notice/noticeEdit',
    name: 'primaryNoticeEdit',
    component: NoticeEdit
}, {
    path: 'primary/notice/noticeDetail',
    name: 'primaryNoticeDetail',
    component: NoticeDetail
}, {
    path: 'primary/setting',
    component: SettingLayout,
    children: [{
        path: '',
        redirect: 'signupSetting'
    }, {
        path: 'signupSetting',
        name: 'primarySignupSetting',
        component: SignupSetting
    }, {
        path: 'notifySetting',
        name: 'primaryNotifySetting',
        component: NotifySetting
    }, {
        path: 'groupingSetting',
        name: 'primaryGroupingSetting',
        component: GroupingSetting
    }, {
        path: 'reviewSetting',
        name: 'primaryReviewSetting',
        component: ReviewSetting
    }, {
        path: 'sendMessage',
        name: 'sendMessage',
        component: SendMessage
    }, {
        path: 'ticketWindcowSetting',
        name: 'ticketWindcowSetting',
        component: TicketWindowSetting
    }, {
        path: 'messageTemplateList',
        name: 'messageTemplateList',
        component: MessageTemplateList
    }, {
        path: 'createTemplate',
        name: 'createTemplate',
        component: () => import('@/views/messageTemplate/createTemplate')
    }, {
        path: 'infoSearch/infoSearchList',
        name: 'infoSearchList',
        component: infoSearchList
    }, {
        path: 'infoSearch/infoSearchAdd',
        name: 'infoSearchAdd',
        component: infoSearchAdd
    }, {
        path: 'infoSearch/infoSearchResultList',
        name: 'infoSearchResultList',
        component: infoSearchResultList
    }]
}, {
    path: 'primary/signup',
    name:'signupLayout',
    component: SignupLayout,
    meta:{
        keepAlive:true
    },
    children: [{
        path: '/',
        redirect: 'signupList'
    }, {
        path: 'signupList',
        name: 'SignupList',
        component: SignupList,
        meta:{
            keepAlive:true
        }
    },{
        path: 'signupAdd',
        name: 'signupAdd',
        component: SignupAdd
    }, {
        path: 'signupDetail',
        name: 'signupDetail',
        component: SignupDetail
    }]
}, {
    path: 'primary/OccupiedStudentList',
    name: 'OccupiedStudentList',
    component: OccupiedStudentList
}, {
    path: 'primary/review',
    component: ReviewLayout,
    children: [{
        path: '',
        redirect: 'reviewOnline'
    }, {
        path: 'reviewOnline',
        name: 'ReviewOnline',
        component: ReviewOnline
    }, {
        path: 'reviewOffline',
        name: 'ReviewOffline',
        component: ReviewOffline
    }, {
        path: 'reviewReserve',
        name: 'reviewReserve',
        component: ReviewReserve
    }, {
        path: 'reviewQuestionnaireDetail',
        name: 'ReviewQuestionnaireDetail',
        component: ReviewQuestionnaireDetail
    }]
}, {
    path: 'primary/accounting',
    component: AccountingLayout,
    children: [{
        path: '',
        redirect: 'dataAccounting'
    }, {
        path: 'dataAccounting',
        name: 'DataAccounting',
        component: DataAccounting
    }, {
        path: 'signupAccounting',
        name: 'SignupAccounting',
        component: SignupAccounting
    }, {
        path: 'reviewAccounting',
        name: 'ReviewAccounting',
        component: ReviewAccounting
    }]
}];
export const primaryOuterRouterList = [{
    path: '/primary/outer/outerNotice',
    name: 'primaryOuterNotice',
    component: OuterNotice
}, {
    path: '/primary/outer/outerLogin',
    name: 'primaryOuterLogin',
    component: OuterLogin
}, {
    path: '/primary/outer/outerQuestionnaire',
    name: 'primaryOuterQuestionnaire',
    component: OuterQuestionnaire
}, {
    path: '/primary/outer/outerQuestionnaireDetail',
    name: 'primaryOuterQuestionnaireDetail',
    component: OuterQuestionnaireDetail
}];






// WEBPACK FOOTER //
// ./src/router/primary.js